import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SUPPORT } from 'business/constants';
import { useUserHasRole } from 'hooks/client';
import { UserRole } from 'business/definitions';
import { some } from 'lodash';
import { MODULES_TRANSLATION_PATH } from './helpers/constants';
import GenericSwitchBar from './ui/GenericSwitchBar';
import SupportTooltip from './ui/SupportTooltip';
import { isEmailDomainSupportWhitelisted } from '../../../helpers/email';

type Props = {
    roles: UserRole[];
    addRole: (r: UserRole) => void;
    removeRole: (r: UserRole) => void;
    supportUsersEmail: string[];
};

const SupportSection = ({
    roles,
    addRole,
    removeRole,
    supportUsersEmail,
}: Props): JSX.Element => {
    const { t } = useTranslation();

    const [shouldShowWarning, setShouldShowWarning] = useState(false);

    const isSupportUser = useUserHasRole(SUPPORT);

    const isCreatedUserSupport = roles.includes(SUPPORT);

    useEffect(() => {
        if (
            isCreatedUserSupport &&
            supportUsersEmail &&
            some(
                supportUsersEmail,
                (email) => !isEmailDomainSupportWhitelisted(email),
            )
        ) {
            setShouldShowWarning(true);
        } else {
            setShouldShowWarning(false);
        }
    }, [isCreatedUserSupport, supportUsersEmail]);

    if (!isSupportUser) return <></>;

    const handleSupportSwitchChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => (event.target.checked ? addRole(SUPPORT) : removeRole(SUPPORT));

    return (
        <GenericSwitchBar
            checked={!!isCreatedUserSupport}
            onChange={handleSupportSwitchChange}
            title={t(`${MODULES_TRANSLATION_PATH}.titles.${SUPPORT}`)}
            tooltipContent={<SupportTooltip />}
            warningMessage={
                shouldShowWarning
                    ? t(
                          `${MODULES_TRANSLATION_PATH}.warningMessages.${SUPPORT}`,
                      )
                    : undefined
            }
        />
    );
};

export default SupportSection;
